import React, { useEffect, useState } from "react";
import "./StockDayRangeData.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function StockapiDayRangeData() {
    // WebSocket connection
    const { options } = useStockApiWebsocket(environment.stockApiDayRangeDataWSUrl);
    const [stockData, setStockData] = useState([]);

    const getIndexTopBottomDataClass = (spotPrice, value) => {
        const diff = Math.abs(spotPrice - value);
        return diff <= 2.5 ? "bg-orange" : "";
    };

    useEffect(() => {
        if (options && Array.isArray(options.stockDayRangeModelList) && options.stockDayRangeModelList.length > 0) {
            setStockData(options);
        }
    }, [options]);

    const getBullishAndBearishClass = (value) => {
        if (!value) return "";
        return value >= 0 ? "bullish-color" : "bearish-color";
    };

    // -------------------
    // Header Data
    // -------------------
    const headerData = [
        {
            label1: "Bull-Count",
            value1: stockData?.bullishStockCount ?? "--",
            label2: "Bear-Count",
            value2: stockData?.bearishStockCount ?? "--",
        },
        {
            label1: "Bull Chg(%)-1",
            value1: Number(stockData?.bullishChangePercentageSum).toFixed(2) ?? "--",
            label2: "Bear Chg(%)-1",
            value2: Number(stockData?.bearishChangePercentageSum).toFixed(2) ?? "--",
        },
         {
            label1: "Bull Chg(%)-2",
            value1: Number((stockData?.bullishChangePercentageSum)*10).toFixed(2) ?? "--",
            label2: "Bear Chg(%)-2",
            value2: Number((stockData?.bearishChangePercentageSum)*10).toFixed(2) ?? "--",
        },
        {
            label1: "Bull Avg-1",
            value1: Number(stockData?.bullishAverage).toFixed(2) ?? "--",
            label2: "Bear Avg-1",
            value2: Number(stockData?.bearishAverage).toFixed(2) ?? "--",
        },
        {
            label1: "Bull Avg-2",
            value1: Number((stockData?.bullishAverage)*10).toFixed(2) ?? "--",
            label2: "Bear Avg-2",
            value2: Number((stockData?.bearishAverage)*10).toFixed(2) ?? "--",
        },
        {
            label1: "ExpDate",
            value1: stockData?.expiryDate ?? "--",
            label2: "DateTime",
            value2: stockData?.currentDateTime ?? "--",
        },
    ];

    return (
        <div className="stock-data-page">
            <header className="header">
                <nav className="nav-container">
                    <div className="left-nav header-flex">
                        <div className="logo-container">
                            <img
                                src="/assets/images/noptionwave-logo-1.png"
                                className="header-logo"
                                alt="noptionwave logo"
                            />
                        </div>

                        {headerData.map((item, idx) => (
                            <div className="header-item" key={idx}>
                                {/* LABEL 1 */}
                                <span className={`header-line ${item.label1.toLowerCase().includes("bull")
                                            ? "bull-label"
                                            : item.label1.toLowerCase().includes("bear")
                                                ? "bear-label"
                                                : ""
                                        }`}
                                >
                                    {item.label1}: {item.value1}
                                </span>

                                {/* LABEL 2 */}
                                <span className={`header-line ${item.label2.toLowerCase().includes("bull")
                                            ? "bull-label"
                                            : item.label2.toLowerCase().includes("bear")
                                                ? "bear-label"
                                                : ""
                                        }`}
                                >
                                    {item.label2}: {item.value2}
                                </span>
                            </div>
                        ))}
                    </div>
                </nav>
            </header>

            <div className="table-container">
                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">
                    <thead>
                        <tr>
                            <th>SYMBOL</th>
                            <th>EXPIRY DATE</th>
                            <th>LOT SIZE</th>
                            <th>PV</th>
                            <th>OPEN PRICE</th>
                            <th>DAY-TOP-1</th>
                            <th>DAY-TOP-2</th>
                            <th>SPOT PRICE</th>
                            <th>DAY-BOTTOM-1</th>
                            <th>DAY-BOTTOM-2</th>
                            <th>CHG PTS</th>
                            <th>CHG %</th>
                        </tr>
                    </thead>

                    <tbody>
                        {stockData?.stockDayRangeModelList?.length > 0 ? (
                            stockData.stockDayRangeModelList.map((row, idx) => (
                                <React.Fragment key={idx}>
                                    <tr>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td>{row.expiryDate ?? "--"}</td>
                                        <td>{row.lotSize ?? "--"}</td>
                                        <td>{row.pointValue ?? "--"}</td>
                                        <td>{row.niftyOpenPrice ?? "--"}</td>

                                        <td className={getIndexTopBottomDataClass(row.niftySpotPrice, row.dayTopOne)}>
                                            {row.dayTopOne ?? "--"} - ({Number(row.dayTopOne - row.niftySpotPrice).toFixed(2)})
                                        </td>

                                        <td className={getIndexTopBottomDataClass(row.niftySpotPrice, row.dayTopTwo)}>
                                            {row.dayTopTwo ?? "--"} - ({Number(row.dayTopTwo - row.niftySpotPrice).toFixed(2)})
                                        </td>

                                        <td>{row.niftySpotPrice ?? "--"}</td>

                                        <td className={getIndexTopBottomDataClass(row.niftySpotPrice, row.dayBottomOne)}>
                                            {row.dayBottomOne ?? "--"} - ({Number(row.niftySpotPrice - row.dayBottomOne).toFixed(2)})
                                        </td>

                                        <td className={getIndexTopBottomDataClass(row.niftySpotPrice, row.dayBottomTwo)}>
                                            {row.dayBottomTwo ?? "--"} - ({Number(row.niftySpotPrice - row.dayBottomTwo).toFixed(2)})
                                        </td>

                                        <td className={getBullishAndBearishClass(row.changePoints)}>
                                            {row.changePoints ?? "--"}
                                        </td>

                                        <td className={getBullishAndBearishClass(row.changePercentange)}>
                                            {row.changePercentange ?? "--"}
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="17">Waiting for live data...</td>
                            </tr>
                        )}
                    </tbody>

                    <tfoot className="fixed-footer">
                        <tr className="footer-left">
                            <td colSpan="12">noptionwave © 2025</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
}
